import { DevAnalyticsProvider } from '@/core/analytics/DevAnalyticsProvider.ts'
import { MixpanelAnalyticsProvider } from '@/core/analytics/MixpanelAnalyticsProvider.ts'
import { AnalyticsProvider } from '@/core/analytics/AnalyticsProvider.ts'
import { isProductionHost } from '@/core/utils/isProductionHost.ts'

const analytics: AnalyticsProvider = isProductionHost()
  ? new MixpanelAnalyticsProvider()
  : new DevAnalyticsProvider()

export { analytics as Analytics }
